<template>
    <v-card 
        :loading="sistemaLoading"
        elevation="2"
        tile
        outlined
        >
        <v-card-text>
            <div v-if="sistemaLoading">
                Cargando...
            </div>
            <div v-else-if="sistemaList.length">
                <component
                    v-for="(sistema, index) of sistemaList"
                    :is="sistema.sistema_type?.slug !== 'monitor' ? 'SistemaCard' : 'MonitorCard'"
                    :key="`sistema-list-${index}-${sistema.id}`" :sistema="sistema"
                    :abilities="abilities"
                    class="mb-4"
                    />
            </div>
            <div v-else>
                No hay sistemas registrados.
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
import SistemaService from '@/services/operadora/comercio/sistema/SistemaService';

import SistemaCard from './card';
import MonitorCard from './monitor-card';

export default {
    components: {
        SistemaCard,
        MonitorCard
    },
    props: {
        params: {},
    },
    data: () => ({
        abilities: [],
        sistemaList: [],
        sistemaLoading: false,
    }),
    methods: {
        getList: function (params) {
            this.sistemaLoading = true;
            SistemaService
                .getList(params)
                .then(({ sistemaList }) => {
                    this.sistemaList = sistemaList;
                }).finally(() => {
                    this.sistemaLoading = false;
                });
        },
        getAbilitiesList: function () {
            SistemaService
                .getAbilitiesList()
                .then(({ abilities }) => {
                    this.abilities = abilities;
                });
        }
    },
    created: function () {
        this.getAbilitiesList();
        this.getList(this.params);
    },
    watch: {
        params: {
            handler: function (params) {
                this.getList(params);
            },
            deep: true,
        }
    }
}
</script>